import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "new-event-as-visitor" as const;

export type NewEventAsVisitorEventData = {
  eventId: string;
};
export type NewEventAsVisitorEvent = AppEvent<
  typeof eventName,
  NewEventAsVisitorEventData
>;

export const isNewEventAsVisitorEvent = (
  event: AnyAppEvent
): event is NewEventAsVisitorEvent => event.name === eventName;

export { eventName as newEventAsVisitor };
